import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ roles }) => {
  const { currentUser } = useAuth();

  // If no user is logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If roles are specified, check if user has required role
  if (roles && !roles.includes(currentUser.role)) {
    // Redirect based on role
    return currentUser.role === 'admin' 
      ? <Navigate to="/admin" />
      : <Navigate to="/" />;
  }

  // If all checks pass, render the child routes
  return <Outlet />;
};

export default ProtectedRoute; 